import { render, staticRenderFns } from "./preview-record.vue?vue&type=template&id=7f8b31e5&scoped=true"
import script from "./preview-record.vue?vue&type=script&lang=js"
export * from "./preview-record.vue?vue&type=script&lang=js"
import style0 from "./preview-record.vue?vue&type=style&index=0&id=7f8b31e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8b31e5",
  null
  
)

export default component.exports